const livedExperienceForm = () => {
    const form = document.querySelector('.js-lived-experience-form');
    let modal;

    const userEligible = () => {
        form.method = 'post';

        form.submit();
    }

    const useNotEligible = () => {
        modal.open();
    }

    const buildModal = () => {
        modal = new tingle.modal({
            stickyFooter: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: "Close",
            onOpen: () => {
                const close = document.querySelector('.tingle-modal .js-lived-experience-form-close');

                if (close) {
                    close.addEventListener('click', () => {
                        modal.close();
                    });
                }
            },
        });

        // set content
        modal.setContent(document.querySelector('.js-lived-experience-form-popup-content').innerHTML);
    }

    const focusOnEl = (el) => {
        let focusTarget;

        if (el.tagName === 'INPUT' || el.tagName === 'SELECT') {
            focusTarget = el;
        } else {
            const button = el.querySelector('button');

            if (button) {
                focusTarget = button;
            }
        }

        if (focusTarget) {
            focusTarget.focus();
        }

        const scrollPosition = window.pageYOffset + el.getBoundingClientRect().top;

        const elements = [
            document.querySelector('.navigation-bar-holder'),
            document.querySelector('.condition-sub-nav')
        ];

        let elHeight = 0;

        elements.forEach(el => {
            if (el) {
                elHeight += el.clientHeight;
            }
        });

        const topHeight = scrollPosition - (elHeight + 30);

        window.scroll(0, topHeight);
    }

    if (form) {
        buildModal();
        form.addEventListener('submit', (e) => {
            e.preventDefault()

            const data = new FormData(form);
            const errorsContainer = form.querySelector('.js-lived-experience-form-errors');
            let requiredFields = [];

            let options = [];
            let requiresExplanation = false;
            let eligible = true;

            const inputs = form.querySelectorAll('input, textarea');

            errorsContainer.innerHTML = null;

            inputs.forEach(input => {
                const field = input.parentNode;
                const errorEl = field.querySelector('.js-lived-experience-form-input-error');

                input.setAttribute('aria-invalid', false);
                field.classList.remove('field--error');

                if (errorEl) {
                    errorEl.innerHTML = null;
                }
            });

            for (let entry of data) {
                if (entry[0] === 'lived-experience[]') {
                    options.push(entry);

                    if (entry[1] === 'I am severely affected by mental illness but do not fit in the categories above (please briefly explain)') {
                        requiresExplanation = true;
                    }

                    if (entry[1] === 'None of the above apply to me') {
                        eligible = false;
                    }
                }
                if (entry[0] === 'explanation') {
                    if (entry[1] === '' && requiresExplanation) {
                        const input = form.querySelector('#lived-experience-' + entry[0]);
                        requiredFields.push({
                            input: input,
                            type: 'required'
                        });
                        input.setAttribute('aria-invalid', true);
                    }
                }
            }

            if (options.length === 0) {
                requiredFields.push({
                    input: 'ALL',
                    type: 'required'
                });
            }

            if (requiredFields.length > 0) {
                let listHtml = ''

                requiredFields.forEach(item => {
                    if (item.input === 'ALL') {
                        listHtml += `<li class='js-lived-experience-form-error' data-input='lived-experience-personal-support'><button type="button">At least one option is required</button></li>`;
                    } else {
                        const field = item.input.parentNode;
                        const label = field.querySelector('label')
                        const errorEl = field.querySelector('.js-lived-experience-form-input-error');

                        field.classList.add('field--error');

                        if (label) {
                            listHtml += `<li class='js-lived-experience-form-error' data-input='${item.input.id}'><button type="button">${label.dataset.label ? label.dataset.label : label.innerHTML} is ${item.type}</button></li>`
                        }

                        if (errorEl) {
                            errorEl.innerHTML = `${label.dataset.label ? label.dataset.label : label.innerHTML} is ${item.type}`
                        }
                    }
                });

                let html = `<p>Please fix the following errors before submitting.</p>`;

                if (listHtml !== '') {
                    html += `<ul>${listHtml}</ul>`;
                }

                errorsContainer.innerHTML = html;

                focusOnEl(errorsContainer);

                form.querySelectorAll('.js-lived-experience-form-error').forEach(error => {
                    error.addEventListener('click', () => {
                        const input = form.querySelector('#' + error.dataset.input);

                        if (input) {
                            input.focus();
                            focusOnEl(input);
                        }
                    });
                });
            } else {
                if (eligible) {
                    userEligible();
                } else {
                    useNotEligible();
                }
            }

        });
    }
}

livedExperienceForm()